<template>
  <template v-if="!readOnly">
    <TextInput
      :label="label"
      :model="model"
      placeholder="https://www.youtube.com/watch?v=6iFbuIpe68k&t=7s"
      :errorMsg="errorMsg"
      @input="prepareVideoId"
    />
  </template>
  <div>
    <label v-if="readOnly" class="form-label text-muted"> {{ label }}</label>
    <iframe
      class="iframe-container rounded-4"
      :class="customClasses"
      v-if="videoLink"
      width="100%"
      height="100%"
      :src="videoLink as string"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :style="style"
    ></iframe>
    <div
      v-else
      class="iframe-container rounded-4 border d-flex justify-content-center align-items-center"
    >
      <p class="text-paragraph text-muted">Nenhum vídeo</p>
    </div>
  </div>
</template>

<style scoped>
.iframe-container {
  aspect-ratio: 16/9;
}
</style>
<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    readOnly?: boolean;
    errorMsg?: string;
    label?: string;
    model?: any;
    value?: string;
    customClasses?: string;
    style?: string;
  }>(),
  {
    readOnly: false,
    errorMsg: "",
    label: "",
    model: () => ({}),
    value: "",
    customClasses: "rounded",
    style: "",
  },
);

const youtubeUrlParser = (value: string) => {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/|shorts\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = value.match(regExp);
  return match && match[7].length == 11
    ? `https://youtube.com/watch?v=${match[7]}`
    : "";
};

const prepareYoutubeLink = (value: string): string | boolean => {
  const parsedUrl = youtubeUrlParser(value);
  const url = parsedUrl.replace("watch?v=", "embed/").split("&")[0];
  if (url != undefined || url != "") {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length == 11) {
      return url;
    }
    return false;
  }
  return false;
};

const videoLink = computed<string | boolean>(() => {
  if (props.model?.$model) {
    return prepareYoutubeLink(props.model.$model);
  }
  if (props.value || props.readOnly) {
    return prepareYoutubeLink(props.value);
  }
  return false;
});

const prepareVideoId = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  const parsedUrl = youtubeUrlParser(value);
  const url = parsedUrl.replace("watch?v=", "embed/").split("&")[0];
  props.model.$model = url;
};
</script>
